var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 100,
    viewBox: "0 0 114 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 10.7143C42.75 4.79911 47.5371 0 53.4375 0H60.5625C66.4629 0 71.25 4.79911 71.25 10.7143V89.2857C71.25 95.2009 66.4629 100 60.5625 100H53.4375C47.5371 100 42.75 95.2009 42.75 89.2857V10.7143ZM0 53.5714C0 47.6562 4.78711 42.8571 10.6875 42.8571H17.8125C23.7129 42.8571 28.5 47.6562 28.5 53.5714V89.2857C28.5 95.2009 23.7129 100 17.8125 100H10.6875C4.78711 100 0 95.2009 0 89.2857V53.5714ZM96.1875 14.2857H103.312C109.213 14.2857 114 19.0848 114 25V89.2857C114 95.2009 109.213 100 103.312 100H96.1875C90.2871 100 85.5 95.2009 85.5 89.2857V25C85.5 19.0848 90.2871 14.2857 96.1875 14.2857Z",
    fill: "#006B8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.3c96c5315eb99b274d2c320b1fc543ab.svg";
export { ForwardRef as ReactComponent };